import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Spinner, Alert, Button } from 'react-bootstrap';
import { AgentHubProvider } from './contexts/AgentHubContext';
import AgentNavbar from './components/AgentNavbar';
import useAgentHub from './hooks/useAgentHub';
import './styles/agent-hub.css';

const AgentHub = () => {
  const { agentId } = useParams();
  const navigate = useNavigate();
  const {
    agent,
    loading,
    error,
    activeTab,
    setActiveTab,
    stats,
    loadAgentData
  } = useAgentHub(agentId);

  useEffect(() => {
    if (!agentId) {
      navigate('/whatsapp-agents');
      return;
    }
    loadAgentData();
  }, [agentId, navigate, loadAgentData]);

  if (loading) {
    return (
      <div className="agent-hub-loading">
        <Container className="text-center py-5">
          <Spinner animation="border" variant="primary" size="lg" />
          <h4 className="mt-3">Carregando Hub do Agente...</h4>
          <p className="text-muted">Preparando ambiente de gestão</p>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">
          <Alert.Heading>Erro ao carregar agente</Alert.Heading>
          <p>{error}</p>
          <Button variant="outline-danger" onClick={() => navigate('/whatsapp-agents')}>
            Voltar para Agentes
          </Button>
        </Alert>
      </Container>
    );
  }

  if (!agent) {
    return (
      <Container className="py-5">
        <Alert variant="warning">
          <Alert.Heading>Agente não encontrado</Alert.Heading>
          <p>O agente solicitado não foi encontrado ou não existe.</p>
          <Button variant="outline-warning" onClick={() => navigate('/whatsapp-agents')}>
            Voltar para Agentes
          </Button>
        </Alert>
      </Container>
    );
  }

  return (
    <AgentHubProvider value={{ agent, agentId, stats, activeTab, setActiveTab, agentContext: agent }}>
      <div className="agent-hub-container">
          <AgentNavbar />
      </div>
    </AgentHubProvider>
  );
};

export default AgentHub;